module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAUCAYAAABiS3YzAAABKUlEQVR42q2U0U3DQBAF5xAFpANMBUkHhA5SQjogHSQtUIFFBYgKnA5wKnBSQUIFw88ajHUYC2elk2V7b+7p9u3CiFBn6kZdca1QS/VVPavLawALtYnnTq2upXLXuYazWkxVaRcSasupKstM0QbV3raJwAoogDtgAczi/b67IaV0UZ+BRq2BY6wTUKeU9ilOrIA98AHUwCUSjkM2i0O76wF4Q11Mvvzvg56+3BGX30wBB/AnYwpY3f669z/gQWAnaaM2I4HrHPAmk7uP6o+JC3DouyQHLcJzY6IG5v2POegy1OZ8Sa8RjsCs/y8HnYeCbltuo4OqTEHq6MBB6KKFqmvgPdQ/Ai9AFTOhhR/60FxFz60DQtlywHrt8F6PGXflXxM+8jbtrO3GJ8LuQ6zvH4SRAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/Themes/star-icon.png
// module id = 624
// module chunks = 0 1 2 3 4